import React from 'react';
import ApiTripChange from '../../code/api/ApiTripChange';
import FileUploaderSingle from '../FileUploaderSingle';
import Api_Config from '../../code/api/ApiConfig';
import TripChangeInfo from '../../code/models/TripChangeInfo';
import { ImportDocumentType } from '../../code/enums/Enums';
import '../../css/adminbidpackagestripchange.css';
import ApiDocument from '../../code/api/ApiDocument';
import Auth from "../../code/auth/Auth";
import FileUploaderModalForm from "../FileUploaderModalForm";

interface IAdminBidPackagesTripChange { }

export default function AdminBidPackagesTripChange({ }: IAdminBidPackagesTripChange) {
    const [currentInfo, setCurrentInfo] = React.useState<TripChangeInfo | null>(null);

    React.useEffect(() => {
        loadHistory();
    }, []);

    function loadHistory() {
        ApiTripChange.getTripChangeInfo().then(data => {
            if (!!data) {
                setCurrentInfo(data);
            }
        });
    }

    function getLastFileName(): any {
        var currentFileGroup = currentInfo?.currentFileGroup;
        var comp = Api_Config.getSelectedCompany();

        if (currentFileGroup != null) {
            if (currentFileGroup.bidPeriodFiles.length > 0) {
                const theFile = currentFileGroup.bidPeriodFiles[0];
                let token = Auth.getAuthToken();
                return (
                    <a href={`${comp.adminApiUrl}/document/doc/${theFile.bidPeriodFileId}?t=${token}`} target="_blank" >
                        {currentFileGroup.bidPeriodFiles[0].fileName}
                    </a>
                )
            }
        }
        return "N/A";
    }

    function onUploadReportUploadSuccess(fileGroupId: number) {
        ApiDocument.queueImportRequest(fileGroupId).then(resp => {
            loadHistory();
        });
    }

    return (
        <React.Fragment>
            <div className="tripchange-form">
                <div className="tripchange-div">
                    <span className="tripchange-title">Trip Changes</span>
                    {!!currentInfo && <span className="tripchange-label">Bid Period: {currentInfo?.bidPeriod.month}</span>}
                </div>
                <div className="tripchange-info">
                    <div>
                        <span className="tripchange-label">Last Import Date:</span>
                        {(!currentInfo || !currentInfo.lastImport) &&
                            <span className="tripchange-data">None for this bid period.</span>}
                        {!!currentInfo && !!currentInfo.lastImport &&
                            <span className="tripchange-data">{new Date(currentInfo?.lastImport?.statusDate).toLocaleString()}</span>}
                    </div>
                    <div>
                        <span className="tripchange-label">Last Import Status:</span>
                        {(!currentInfo || !currentInfo.lastImport) && <span className="tripchange-data">N/A</span>}
                        {!!currentInfo && !!currentInfo.lastImport && <span className="tripchange-data">{currentInfo?.lastImport?.status}</span>}
                    </div>
                    <div>
                        <span className="tripchange-label">Last Import Message:</span>
                        {(!currentInfo || !currentInfo.lastImport) && <span className="tripchange-data">N/A</span>}
                        {!!currentInfo && !!currentInfo.lastImport && <span className="tripchange-data">{currentInfo?.lastImport?.statusMessage}</span>}
                    </div>
                    <br />
                    <div>
                        <span className="tripchange-label">Last Report Upload Date:</span>
                        {(!currentInfo || !currentInfo.currentFileGroup) && <span className="tripchange-data">None for this bid period.</span>}
                        {!!currentInfo && !!currentInfo.currentFileGroup &&
                            <span className="tripchange-data">{new Date(currentInfo?.currentFileGroup?.statusDate).toLocaleString()}</span>}
                    </div>
                    <div>
                        <span className="tripchange-label">Last Report Upload Status:</span>
                        {(!currentInfo || !currentInfo.currentFileGroup) && <span className="tripchange-data">N/A</span>}
                        {!!currentInfo && !!currentInfo.currentFileGroup && <span className="tripchange-data">{currentInfo?.currentFileGroup?.groupStatus}</span>}
                    </div>
                    <div>
                        <span className="tripchange-label">Last File Name:</span>
                        {(!currentInfo || !currentInfo.currentFileGroup) && <span className="tripchange-data">N/A</span>}
                        {!!currentInfo && !!currentInfo.currentFileGroup && <span className="tripchange-data">{getLastFileName()}</span>}
                    </div>
                </div>
                <div className="tripchange-fileuploader">
                    <FileUploaderModalForm
                        title="Import Trip Changes"
                        fileGroup={ImportDocumentType.trip_change}
                        fileGroupId={currentInfo?.currentFileGroup?.bidPeriodFileGroupId}
                        buttonTextChoose="Browse Documents"
                        buttonTextUpload="Upload and Import"
                        buttonTextMain="Import New Trip Change Document"
                        newGroupOnUpload={true}
                        multiUpload={false}
                        onUploadSuccess={onUploadReportUploadSuccess}
                    />
                </div>
            </div>
        </React.Fragment>
    )
}
